import React from 'react';
import { useTheme } from 'styled-components';

import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ className, onClick }, ref) {
  const { colors } = useTheme();

  return (
    <svg ref={ref} onClick={onClick} width='10px' height='33px' viewBox='0 0 10 43' className={className}>
      <defs>
        <polygon id='rls-path-1' points='386 419 1292 419 1292 462 386 462 396 440.5' />
        <filter x='-0.4%' y='-4.7%' width='100.9%' height='118.6%' filterUnits='objectBoundingBox' id='rls-filter-2'>
          <feOffset dx='0' dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
          <feGaussianBlur stdDeviation='1' in='shadowOffsetOuter1' result='shadowBlurOuter1' />
          <feColorMatrix
            values='0 0 0 0 0.239216   0 0 0 0 0.345098   0 0 0 0 0.501961  0 0 0 0.05 0'
            type='matrix'
            in='shadowBlurOuter1'
          />
        </filter>
      </defs>
      <g id='rls-Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='rls-FOLLOW-THIS-Copy-4' transform='translate(-386.000000, -419.000000)'>
          <g id='rls-Rectangle-5-Copy-50'>
            <use fill={colors.grey00_5} fillOpacity='1' filter='url(#rls-filter-2)' xlinkHref='#rls-path-1' />
            <use fill={colors.grey00_5} fillRule='evenodd' xlinkHref='#rls-path-1' />
          </g>
        </g>
      </g>
    </svg>
  );
});

export default React.memo(Icon);
